import React from 'react';
import type { DokumentyDokumentDto } from '@gov-nx/api';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { Button, Dialog } from '@gov-nx/ui/web';
import { MarkdownRender } from '../../../Markdown/MarkdownRender';

interface DeletePromptProps {
	code: PageCode;
	documentToDelete?: DokumentyDokumentDto;
	onClose: () => void;
	onDelete: () => void;
}

export const DeletePrompt = ({
	code,
	documentToDelete,
	onClose,
	onDelete,
}: DeletePromptProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<Dialog
			isOpen={!!documentToDelete}
			onClose={() => onClose()}
			title={<h3>{tsn('vlastni-doklady.mazani.titulek')}</h3>}
			footer={
				<>
					<Button
						type="base"
						color="primary"
						size="m"
						onClick={() => onClose()}
						aria-label={tsn('vlastni-doklady.akce.mazani-zrusit')}>
						{tsn('vlastni-doklady.akce.mazani-zrusit')}
					</Button>
					<Button
						type="solid"
						color="error"
						size="m"
						onClick={() => onDelete()}
						aria-label={tsn('vlastni-doklady.akce.mazani-potvrdit')}>
						{tsn('vlastni-doklady.akce.mazani-potvrdit')}
					</Button>
				</>
			}>
			<MarkdownRender>
				{tsn('vlastni-doklady.mazani.popis', {
					nazevDokladu: documentToDelete?.nazev ?? '',
				})}
			</MarkdownRender>
		</Dialog>
	);
};
